// removed by extract-text-webpack-plugin
module.exports = {"scrapWrap":"qempo_ScrapInputBlock_scrapWrap-1atnp6X","scrapFormContent":"qempo_ScrapInputBlock_scrapFormContent-1IKGMr2","inputWrap":"qempo_ScrapInputBlock_inputWrap-3NXHR4I"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/product-list/components/ScrapInputBlock/ScrapInputBlock.scss
// module id = 2002
// module chunks = 0